import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EApprovalStatus } from 'src/app/models/approval.model';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-status-approval-filter',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './status-approval-filter.component.html',
    styleUrls: ['./status-approval-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: StatusApprovalFilterComponent, multi: true }]
})
export class StatusApprovalFilterComponent {
  enumQStatus = EApprovalStatus;
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  selectedFilter$ = toSignal(this.#manipulationsToolbarStore.selectedFilter$);
  statusList = [{
    status: EApprovalStatus.PendingApproval,
    choosed: false
  },
  {
    status: EApprovalStatus.PendingPrevApproval,
    choosed: false
  },
  {
    status: EApprovalStatus.Rejected,
    choosed: false
  },
  {
    status: EApprovalStatus.Approved,
    choosed: false
  },

  ];

  ngOnInit() {
    this.statusList.map(x => this.selectedFilter$()?.statusApproval?.includes(x.status) ? x.choosed = true : false)
  }

  valueControl = new FormControl<EApprovalStatus[] | null>(null);
  callBackFunction: Function = () => { };

  writeValue(obj: any): void {
    this.valueControl.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  selectStatus(item: any) {
    item.choosed = !item.choosed;
    const itemsSelected = this.statusList.filter(x => x.choosed == true).map(x => { return x.status });
    this.valueControl.setValue(itemsSelected);
    if (this.callBackFunction) {
      this.callBackFunction(this.valueControl.value);
    }
  }
}
